var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33334 13.6666C1.04467 13.6666 0 12.622 0 11.3333C0 10.2163 0.784936 9.28255 1.83334 9.05366V6.99995C1.83334 6.72379 2.05719 6.49995 2.33334 6.49995H5.5V4.94627C4.45161 4.71739 3.66666 3.78371 3.66666 2.66667C3.66666 1.37795 4.71134 0.333305 6 0.333305C7.28864 0.333305 8.33336 1.37795 8.33336 2.66667C8.33336 3.78371 7.5484 4.71739 6.5 4.94627V6.49995H9.66664C9.9428 6.49995 10.1666 6.72379 10.1666 6.99995V9.05366C11.215 9.28255 12 10.2163 12 11.3333C12 12.622 10.9554 13.6666 9.66664 13.6666C8.378 13.6666 7.33336 12.622 7.33336 11.3333C7.33336 10.2163 8.11824 9.28255 9.16664 9.05366V7.49996H2.83334V9.05366C3.88173 9.28255 4.66666 10.2163 4.66666 11.3333C4.66666 12.622 3.622 13.6666 2.33334 13.6666Z",
    fill: "url(#paint0_linear_1612_286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_286",
    x1: 0.0428568,
    y1: 7.0004,
    x2: 12.0022,
    y2: 7.03181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.464f671e099bd6681f4f5d9fe90fa008.svg";
export { ForwardRef as ReactComponent };